import {
  CheckIcon,
  CodeIcon,
  ServerIcon,
  SparklesIcon,
  SupportIcon,
} from "@heroicons/react/solid";
import React from "react";
import { services } from "../data";

const icons = [ServerIcon, CodeIcon, SparklesIcon, SupportIcon];

export default function Services() {
  return (
    <section id="services" className="bg-white text-gray-900">
      <div className="container px-5 py-16 mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold title-font text-gray-900 mb-4">
            What We Do
          </h1>
          <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-gray-600">
            We design it, build it, and keep it running. Four ways we work
            with clients, from a one-off modernisation project to ongoing
            senior support.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((service, index) => {
            const Icon = icons[index];
            return (
            <div
              key={service.number}
              className="bg-purple-50 rounded-xl p-8 flex flex-col h-full border border-purple-100"
            >
              <div className="w-12 h-12 rounded-xl bg-purple-600 flex items-center justify-center mb-4">
                <Icon className="w-6 h-6 text-white" />
              </div>
              <span className="text-purple-600 text-sm font-semibold tracking-widest title-font">
                {service.number}
              </span>
              <h2 className="text-gray-900 text-xl title-font font-medium mt-2 mb-1">
                {service.title}
              </h2>
              <p className="text-purple-600 text-xs uppercase tracking-wide mb-3 font-medium">
                {service.audience}
              </p>
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                {service.description}
              </p>
              <ul className="space-y-2 mt-auto">
                {service.items.map((item) => (
                  <li key={item} className="flex items-start text-sm text-gray-700">
                    <CheckIcon className="text-purple-600 w-4 h-4 flex-shrink-0 mr-2 mt-0.5" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
